import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DealershipTable = ({ 
  dealerships, 
  onEdit, 
  onView, 
  onDelete, 
  selectedItems, 
  onSelectItem, 
  onSelectAll 
}) => {
  const [contextMenu, setContextMenu] = useState({ show: false, x: 0, y: 0, dealership: null });

  const handleContextMenu = (e, dealership) => {
    e?.preventDefault();
    setContextMenu({
      show: true,
      x: e?.clientX,
      y: e?.clientY,
      dealership
    });
  };

  const handleCloseContextMenu = () => {
    setContextMenu({ show: false, x: 0, y: 0, dealership: null });
  };

  const handleContextAction = (action) => {
    if (contextMenu?.dealership) {
      switch (action) {
        case 'edit':
          onEdit(contextMenu?.dealership);
          break;
        case 'view':
          onView(contextMenu?.dealership);
          break;
        case 'delete':
          onDelete(contextMenu?.dealership);
          break;
      }
    }
    handleCloseContextMenu();
  };



  return (
    <>
      {/* Desktop Table */}
      <div className="hidden lg:block bg-card rounded-lg border border-border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted">
              <tr>
                <th className="w-12 px-4 py-3">
                  <input
                    type="checkbox"
                    checked={selectedItems?.length === dealerships?.length}
                    onChange={(e) => onSelectAll(e?.target?.checked)}
                    className="rounded border-border"
                  />
                </th>
                <th className="text-left px-4 py-3 font-medium text-muted-foreground">Autohaus</th>
                <th className="text-left px-4 py-3 font-medium text-muted-foreground">Standort</th>
                <th className="text-left px-4 py-3 font-medium text-muted-foreground">Kontakt</th>
                <th className="text-left px-4 py-3 font-medium text-muted-foreground">Aufträge</th>
                <th className="text-left px-4 py-3 font-medium text-muted-foreground">Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {dealerships?.map((dealership) => (
                <tr
                  key={dealership?.id}
                  className="border-t border-border hover:bg-muted/50 transition-colors duration-150"
                  onContextMenu={(e) => handleContextMenu(e, dealership)}
                >
                  <td className="px-4 py-4">
                    <input
                      type="checkbox"
                      checked={selectedItems?.includes(dealership?.id)}
                      onChange={(e) => onSelectItem(dealership?.id, e?.target?.checked)}
                      className="rounded border-border"
                    />
                  </td>
                  <td className="px-4 py-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center">
                        <Icon name="Building2" size={20} className="text-muted-foreground" />
                      </div>
                      <div>
                        <div className="font-medium text-foreground">{dealership?.name}</div>
                        <div className="text-sm text-muted-foreground">ID: {dealership?.id}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <div>
                      <div className="font-medium">{dealership?.city}</div>
                      <div className="text-sm text-muted-foreground">{dealership?.zipCode}</div>
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <div>
                      <div className="font-medium">{dealership?.contactPerson}</div>
                      <div className="text-sm text-muted-foreground">{dealership?.email}</div>
                      <div className="text-sm text-muted-foreground">{dealership?.phone}</div>
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="space-y-1">
                      <div className="flex items-center space-x-2">
                        <span className="font-semibold text-lg text-primary">{dealership?.activeOrders}</span>
                        <span className="text-sm text-muted-foreground">aktiv</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <span className="font-semibold text-sm text-success">{dealership?.completedOrders}</span>
                        <span className="text-xs text-muted-foreground">abgeschlossen</span>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="flex items-center space-x-1">
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => onView(dealership)}
                        className="h-8 w-8"
                      >
                        <Icon name="Eye" size={16} />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => onEdit(dealership)}
                        className="h-8 w-8"
                      >
                        <Icon name="Edit" size={16} />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => onDelete(dealership)}
                        className="h-8 w-8 text-error hover:text-error"
                      >
                        <Icon name="Trash2" size={16} />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Mobile Cards */}
      <div className="lg:hidden space-y-4">
        {dealerships?.map((dealership) => (
          <div
            key={dealership?.id}
            className="bg-card rounded-lg border border-border p-4"
            onContextMenu={(e) => handleContextMenu(e, dealership)}
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  checked={selectedItems?.includes(dealership?.id)}
                  onChange={(e) => onSelectItem(dealership?.id, e?.target?.checked)}
                  className="rounded border-border"
                />
                <div className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center">
                  <Icon name="Building2" size={20} className="text-muted-foreground" />
                </div>
                <div>
                  <div className="font-medium text-foreground">{dealership?.name}</div>
                  <div className="text-sm text-muted-foreground">ID: {dealership?.id}</div>
                </div>
              </div>

            </div>

            <div className="mb-4">
              <div className="text-sm text-muted-foreground mb-1">Aufträge</div>
              <div className="space-y-1">
                <div className="flex items-center space-x-1">
                  <span className="font-semibold text-primary">{dealership?.activeOrders}</span>
                  <span className="text-sm text-muted-foreground">aktiv</span>
                </div>
                <div className="flex items-center space-x-1">
                  <span className="font-semibold text-sm text-success">{dealership?.completedOrders}</span>
                  <span className="text-xs text-muted-foreground">abgeschlossen</span>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <div className="text-sm text-muted-foreground mb-1">Standort</div>
              <div className="font-medium">{dealership?.city}, {dealership?.zipCode}</div>
            </div>

            <div className="mb-4">
              <div className="text-sm text-muted-foreground mb-1">Kontakt</div>
              <div className="font-medium">{dealership?.contactPerson}</div>
              <div className="text-sm text-muted-foreground">{dealership?.email}</div>
              <div className="text-sm text-muted-foreground">{dealership?.phone}</div>
            </div>

            <div className="flex items-center justify-end space-x-2">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onView(dealership)}
              >
                <Icon name="Eye" size={16} className="mr-2" />
                Anzeigen
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onEdit(dealership)}
              >
                <Icon name="Edit" size={16} className="mr-2" />
                Bearbeiten
              </Button>
            </div>
          </div>
        ))}
      </div>
      {/* Context Menu */}
      {contextMenu?.show && (
        <>
          <div
            className="fixed inset-0 z-1000"
            onClick={handleCloseContextMenu}
          />
          <div
            className="fixed bg-popover border border-border rounded-lg shadow-modal py-2 z-1100"
            style={{ left: contextMenu?.x, top: contextMenu?.y }}
          >
            <button
              onClick={() => handleContextAction('view')}
              className="w-full flex items-center px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-colors duration-150"
            >
              <Icon name="Eye" size={16} className="mr-3" />
              Details anzeigen
            </button>
            <button
              onClick={() => handleContextAction('edit')}
              className="w-full flex items-center px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-colors duration-150"
            >
              <Icon name="Edit" size={16} className="mr-3" />
              Bearbeiten
            </button>
            <div className="border-t border-border my-1" />
            <button
              onClick={() => handleContextAction('delete')}
              className="w-full flex items-center px-4 py-2 text-sm text-error hover:bg-muted transition-colors duration-150"
            >
              <Icon name="Trash2" size={16} className="mr-3" />
              Löschen
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default DealershipTable;